<template>
  <div class="topic-type label-topic">
    <div class="topic-container">
      <topic-info :info="info" />
      <div class="operation">
        <div class="record-container">
          <div class="left">
            <div class="record-list">
              <div class="record-item" v-for="(item, index) in answerRecord">
                <p>{{ item.name }}</p>
                <div class="delete" @click="deleteRecord(item,index)">
                  <van-icon name="cross" />
                </div>
              </div>
            </div>
            <div class="record-statistics">
              <p>有效个数：{{ answerRecord.length }}个</p>
            </div>
          </div>
          <div class="right">
            <!-- 标签列表 -->
            <div class="tag-list">
              <div class="tag-item" :class="{active: getSelectedStatus(item)}" v-for="(item, index) in info.tag_list" :key="index" @click="handleSelect(item)">
                <p>{{ item }}</p>
              </div>
            </div>
            <!-- 自定义输入 -->
            <div class="input-container">
              <van-field v-model.trim="customInput" maxlength="6" placeholder="请输入项目" />
              <van-button @click="addCustomProject">添加</van-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 指令 -->
    <div class="instruction-container" v-if="info.edict">
      <div class="content" :class="{open: instructionShow}">
        <p v-show="instructionShow">{{ info.edict }}</p>
        <van-icon name="arrow-left" v-show="instructionShow" @click="instructionShow = false" />
      </div>
      <div class="btn" @click="instructionShow = true">
        <img src="@/assets/img/instruction.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import TopicInfo from "../TopicInfo";
export default {
  name: "LabelTopic",
  components: {
    TopicInfo
  },
  props: {
    value: {
      type: [Number, String],
      default: ""
    },
    topicInfo: {
      type: Object,
      required: true
    },
    isHand: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      info: {},
      score: 0,
      instructionShow: false,
      answerRecord: [],
      customInput: '',
      customItem: '',
    }
  },
  watch: {
    value: {
      handler(val) {
        this.score = val;
      },
      immediate: true
    }
  },
  created() {
    this.info = this.$route.query.topic_sort * 1 > 0 ? this.topicInfo.topic_info : this.topicInfo;
    // 初始化答题记录
    if (this.topicInfo.son_toprecrd) {
      this.answerRecord = JSON.parse(JSON.stringify(this.topicInfo.son_toprecrd));
    }
  },
  methods: {
    getSelectedStatus(item) {
      return this.answerRecord.some(v => v.name === item);
    },
    handleSelect(item) {
      if (this.answerRecord.some(e => e.name === item)) return
      this.answerRecord.push({
        type: 1,
        name: item
      });
      if (this.isHand) {
        this.$emit('update:isHand', false);
      }
      this.$nextTick(() => {
        this.calculateScore();
      });
    },
    // 添加自定义项目
    async addCustomProject() {
      if (!this.customInput) {
        return this.$vantnotify('添加项目名称不能为空');
      };
      let flag = this.info.tag_list.some(item => item === this.customInput) || this.answerRecord.some(item => item.name === this.customInput)
      if (flag) {
        return this.$vantnotify('该项目已存在');
      };
      this.answerRecord.push({
        type: 0,
        name: this.customInput
      });
      this.customInput = '';
      if (this.isHand) {
        this.$emit('update:isHand', false);
      }
      this.$nextTick(() => {
        this.calculateScore();
      });
    },
    deleteRecord(item, index) {
      this.answerRecord.splice(index, 1)
      if (this.isHand) {
        this.$emit('update:isHand', false);
      }
      this.$nextTick(() => {
        this.calculateScore();
      })
    },
    // 计算分数
    calculateScore() {
      if (this.isHand) return;
      let length = this.answerRecord.length;
      if (length === 0) {
        this.score = '';
      } else {
        if (length >= this.info.full_mark * 1) {
          this.score = 1;
        } else if (length >= this.info.half_mark * 1) {
          this.score = 0.5;
        } else {
          this.score = 0;
        }
      }
      this.$emit('input', this.score);
    }
  }
}
</script>

<style lang="less" scoped>
.operation {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0.2rem 0.15rem;
  overflow-y: scroll;
  .record-container {
    height: 50vh;
    display: flex;
    background: #fff;
    box-shadow: 0 0 0.2rem 1px rgba(255, 183, 142, 0.57);
    border-radius: 0.2rem;
    .left {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 0.15rem 0.22rem;
      .record-list {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow-y: scroll;
        .record-item {
          display: flex;
          align-items: center;
          height: 0.34rem;
          background: linear-gradient(180deg, #fff6e5 0%, #ffebd4 100%);
          box-shadow: inset 0 0 0.06rem 1px #ffaa71;
          border-radius: 0.1rem;
          font-size: 0.14rem;
          color: #630200;
          line-height: 0.34rem;
          margin: 0 0.16rem 0.13rem 0;
          padding: 0 0.12rem;
        }
        .delete {
          width: 0.16rem;
          height: 0.16rem;
          background: #fff;
          border-radius: 50%;
          font-size: 0.12rem;
          color: #ff7170;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 0.08rem;
        }
      }
      .record-statistics {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        font-size: 0.15rem;
        color: #630200;
        margin-top: 0.05rem;
      }
    }
    .right {
      width: 3.3rem;
      background: linear-gradient(
        135deg,
        #ffe0cf 0%,
        #fffde1 46%,
        #ffd8c5 100%
      );
      border-radius: 0 0.2rem 0.2rem 0;
      border: 1px solid #ffc8a9;
      border-left-width: 0.04rem;
      padding: 0.22rem 0.16rem;
      display: flex;
      flex-direction: column;
      .tag-list {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        flex: 1;
        overflow-y: scroll;
      }
      .tag-item {
        margin: 0 0.1rem 0.12rem 0;
        line-height: 0.34rem;
        background: linear-gradient(180deg, #fff6e5 0%, #ffebd4 100%);
        box-shadow: inset 0 0 0.06rem 1px #ffaa71;
        border-radius: 0.1rem;
        padding: 0 0.12rem;
        font-size: 0.14rem;
        color: #630200;
        &.active {
          background: #ffe56f;
          box-shadow: inset 0 0 0.1rem 1px #ff6f00;
        }
      }
      .input-container {
        height: 0.32rem;
        background: #ffffff;
        overflow: hidden;
        display: flex;
        align-items: center;
        width: fit-content;
        margin-top: 0.1rem;
        .van-cell {
          width: 1.8rem;
          height: 100%;
          padding: 0 0.08rem;
          font-size: 0.14rem;
          border-radius: 0.04rem 0 0 0.04rem;
          line-height: 0.3rem;
          border: 1px solid #ff7e2b;
          &::after {
            display: none;
          }
        }
        .van-button {
          height: 100%;
          border: none;
          border-radius: 0 0.04rem 0.04rem 0;
          background: linear-gradient(180deg, #ff8927 0%, #ff6238 100%);
          font-size: 0.14rem;
          color: #fff;
        }
      }
    }
  }
}
.instruction-container {
  min-width: 0.46rem;
  height: 0.46rem;
  position: fixed;
  bottom: 1rem;
  left: 0;
  border-radius: 0.23rem;
  .content {
    width: 0;
    height: 0.43rem;
    background: linear-gradient(205deg, #ffecd6 0%, #ffda95 100%);
    border-radius: 0 0.2rem 0.2rem 0;
    border: 1px solid #ffc767;
    font-size: 0.12rem;
    color: #540200;
    line-height: 0.14rem;
    position: absolute;
    left: 0.2rem;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    transition: all 0.1s ease;
    box-sizing: border-box;
    p {
      // 限制最多显示两行
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
      word-break: break-all;
    }
    .van-icon {
      color: #f59f0c;
      font-size: 0.14rem;
      margin-left: 0.05rem;
    }
    &.open {
      width: max-content;
      max-width: 3rem;
      padding: 0 0.15rem 0 0.3rem;
    }
  }
  .btn {
    width: 0.46rem;
    height: 0.46rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>